import { useMutation, useQueryClient } from '@tanstack/react-query';
import { roomWantedApi } from '../api/roomWanted.api';
import { roomWantedKeys } from '../api/roomWanted.keys';
import toast from 'react-hot-toast';

export function useUpdateRoomWanted() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: any) => roomWantedApi.update(id, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: roomWantedKeys.all });
      toast.success('Room wanted ad updated');
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'Failed to update');
    },
  });
}

export function useDeleteRoomWanted() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => roomWantedApi.delete(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: roomWantedKeys.all });
      toast.success('Room wanted ad deleted');
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'Failed to delete');
    },
  });
}
